<div class="cancelled-container">
  <div class="cancelled-content">
    <h1>Checkout Incomplete</h1>
    <p>
      You've left the checkout process without completing your subscription. No
      charges have been made.
    </p>
    <div class="actions">
      <button (click)="navigateToHome()" class="exit-button">Exit</button>
    </div>
  </div>
</div>
